import { ReviewList } from "components/organisms/ReviewList";
import { FortuneTellerProfile } from "features/fortune-tellers/components/FortuneTellerProfile";
import { FortuneTellerMenuList } from "features/fortune-tellers/components/FortuneTellerMenuList";
import { SampleChatRoomLink } from "features/fortune-tellers/components/SampleChatRoomLink";
import { useRouter } from "next/router";
import { Paths } from "utils/routes";
import { useFortuneTeller } from "repositories/hooks";
import { SelfIntroduction } from "features/fortune-tellers/components/SelfIntroduction";
import { fortuneTellerTab, FortuneTellerTab } from "./FortuneTellerTab";
import { Scrollable } from "shared/hooks/useScroll";
import {
  CallEndNotificationSettingModal,
  CallEndNotificationSettingModalProps,
} from "./CallEndNotificationSettingModal";
import { useModal } from "mui-modal-provider";
import { useEffect, useRef } from "react";
import { ShowFnOutput } from "mui-modal-provider/dist/types";
import { useCallEndNotificationList } from "features/CallEndNotification/hooks/useCallEndNotificationList";

export const FortuneTellerDetailPresenter = () => {
  const { query, push } = useRouter();

  const { fortuneTeller } = useFortuneTeller(query.id);
  const { callEndNotifications, isLoading } = useCallEndNotificationList({
    fortuneTellerIds: [query.id],
  });
  const isSubscribed = callEndNotifications.length > 0;

  const { showModal, destroyModal } = useModal();
  const modal =
    useRef<ShowFnOutput<CallEndNotificationSettingModalProps>>(null);

  useEffect(() => {
    if (isLoading) return;

    if (fortuneTeller && fortuneTeller?.isCalling && !isSubscribed) {
      modal.current = showModal(CallEndNotificationSettingModal, {
        fortuneTeller,
        onDismiss: () => destroyModal(modal.current.id),
      });
    }
  }, [isLoading, fortuneTeller, isSubscribed, showModal, destroyModal]);

  const goToReviews = () =>
    push(Paths.fortuneTellers.reviews(fortuneTeller.id));

  return (
    <div tw="relative mb-16">
      <FortuneTellerProfile fortuneTeller={fortuneTeller} />
      {fortuneTeller?.sampleChatRoom && (
        <SampleChatRoomLink
          sampleChatRoom={fortuneTeller.sampleChatRoom}
          tw="mt-8"
        />
      )}
      <FortuneTellerTab />
      <div tw="py-3 px-5">
        <Scrollable name={fortuneTellerTab.profile.to}>
          <SelfIntroduction
            selfIntroduction={fortuneTeller?.selfIntroduction}
          />
        </Scrollable>
        <Scrollable name={fortuneTellerTab.menu.to}>
          {fortuneTeller?.telFortunes.length > 0 && (
            <FortuneTellerMenuList
              tw="mt-8"
              title="電話占いメニュー"
              menus={fortuneTeller?.telFortunes}
              fortuneTeller={fortuneTeller}
            />
          )}
          <FortuneTellerMenuList
            tw="mt-8"
            title="チャット占いメニュー"
            menus={fortuneTeller?.fortunes}
            fortuneTeller={fortuneTeller}
          />
        </Scrollable>
        <Scrollable name={fortuneTellerTab.review.to}>
          <ReviewList
            tw="mt-8"
            reviews={fortuneTeller?.reviews}
            goToReviews={goToReviews}
          />
        </Scrollable>
      </div>
    </div>
  );
};
